import { call, put, takeLatest } from 'redux-saga/effects';
import {
  GET_MEDIA_REQUEST,
  GET_MEDIA_REQUEST_SUCCESS,
  GET_MEDIA_REQUEST_ERROR
} from '../types/media';
import services from '../../services';

function* getMediaSaga({ payload }) {
  try {
    const { error, response } = yield call(
      services.media.getMedia,
      payload
    );

    if (error) {
      yield put({ type: GET_MEDIA_REQUEST_ERROR, payload: error });
    } else {
      yield put({
        type: GET_MEDIA_REQUEST_SUCCESS,
        payload: response,
      });
    }
  } catch (error) {
    yield put({
      type: GET_MEDIA_REQUEST_ERROR,
      payload: "Error al obtener la actividad del grupo",
    });
  }
}

export default function* mediaSaga() {
  yield takeLatest<any>(GET_MEDIA_REQUEST, getMediaSaga);
}
